import * as React from 'react';

import {EarnedBonusReportContent} from '/component/partial/reportCard/EarnedBonusReportContent';
import {useTranslation} from '/provider/TranslationProvider';
interface EarnedQsbData {
  earnedQsbOn: Date;
  newOrderingEntitiesCount: number;
  qsbFqv: number;
}

interface Props {
  recordData: EarnedQsbData;
}

export const EarnedQsbReportContent: React.FC<Props> = ({
  recordData: {earnedQsbOn, newOrderingEntitiesCount, qsbFqv},
}) => {
  const record = {
    earnedOn: earnedQsbOn,
    newOrderingEntitiesCount,
    fqv: qsbFqv,
  };
  const {tt} = useTranslation('reportCardContent.earnedQsb');
  return (
    <EarnedBonusReportContent
      recordData={record}
      bonusTitle={tt('title', 'Earned Quick Start Bonus')}
      fqvName={tt('fqvDuringCabPeriod', 'FQV during QSB Period')}
    />
  );
};
